// import logo from '../assets/images/logo.svg';

const Logo = () => {
  return <div></div>;
};
export default Logo;
